:host {
  display: block;
}

.card {
  display: flex;
  flex-direction: column;
  width: 100%;
  text-decoration: none;
  color: #333333;
  padding: 10px;
  box-sizing: border-box;
  background: var(--pes-product-card-bgcolor, inherit);
}

@media screen and (min-width: 980px) {
  .card {
    flex-direction: row;
    padding: 16px;
  }
}

.card__img {
  width: 150px;
  height: 100%;
}

@media screen and (min-width: 980px) {
  .card__img {
    width: 70px;
    flex-shrink: 0;
  }
}

.card__info {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

@media screen and (min-width: 980px) {
  .card__info {
    flex: 1 1;
  }

  :host(:not([dir="rtl"])) .card__info {
    margin-left: 10px;
  }

  :host([dir="rtl"]) .card__info {
    margin-right: 10px;
  }
}

.card__name {
  color: #626469;
  font-size: 10px;
}

.card__description {
  margin: 7px 0;
  font-size: 14px;
}

@media screen and (min-width: 980px) {
  .card__description {
    margin: 8px 0;
  }
}